import CustomBanner from '@/components/CustomBanner';
import { useUpgradeTracking } from '@/hooks/useUpgradeTracking';
import { ILanguageList } from '@/types/language';
import { getAddLanguageQuota } from '../languages.config';

// Informational upsell shown above the Languages card whenever the merchant is gated
// (Free, or a paid plan at its language limit). Hidden when there's room to add.
const LanguageUpgradeBanner = ({ list }: { list: ILanguageList }) => {
  const { navigateToPlan } = useUpgradeTracking();
  const { banner } = getAddLanguageQuota(list);

  if (!banner) return null;

  return (
    <CustomBanner
      tone="info"
      title={banner.title}
      action={{
        content: 'Upgrade now',
        onAction: () => navigateToPlan({ trigger_type: 'feature_gate', trigger_element: 'Upgrade now', feature: 'multi_language' }),
      }}
    >
      {banner.body}
    </CustomBanner>
  );
};

export default LanguageUpgradeBanner;
